/**
 * Option lists for the Precision Analysis enrollment modal demographic
 * dropdowns. Centralised so the Vue modal, the admin preview, and any
 * tests render the same values.
 *
 * `value` is what the form submits; `label` is what visitors see.
 */

export const ROLE_OPTIONS = [
  { value: 'patient_mbc', label: 'Patient with MBC' },
  { value: 'caregiver', label: 'Caregiver' },
  { value: 'oncologist', label: 'Oncologist' },
  { value: 'scientist', label: 'Scientist/Researcher' },
  { value: 'other', label: 'Other' },
]

export const GENDER_OPTIONS = [
  { value: 'female', label: 'Female' },
  { value: 'male', label: 'Male' },
  { value: 'non_binary', label: 'Non-binary' },
  { value: 'self_describe', label: 'Prefer to self-describe' },
  { value: 'prefer_not_to_say', label: 'Prefer not to say' },
]

// OMB-2024 minimum categories. "Hispanic or Latino" is its own option
// here (rather than a separate ethnicity field) to keep the form to a
// single demographic selector — clearer for visitors and adequate for
// the program's reporting needs.
export const RACE_OPTIONS = [
  { value: 'asian', label: 'Asian' },
  { value: 'black', label: 'Black or African American' },
  { value: 'hispanic_latino', label: 'Hispanic or Latino' },
  { value: 'mena', label: 'Middle Eastern or North African' },
  { value: 'native_american', label: 'Native American or Alaska Native' },
  { value: 'pacific_islander', label: 'Native Hawaiian or Pacific Islander' },
  { value: 'white', label: 'White' },
  { value: 'other', label: 'Other' },
  { value: 'prefer_not_to_say', label: 'Prefer not to say' },
]

export const AGE_OPTIONS = [
  { value: '18-24', label: '18–24' },
  { value: '25-34', label: '25–34' },
  { value: '35-44', label: '35–44' },
  { value: '45-54', label: '45–54' },
  { value: '55-64', label: '55–64' },
  { value: '65+', label: '65+' },
]
